import { createSlice } from "@reduxjs/toolkit";
import {
  viewInternship,
  singleInternship,
  newInternship,
  updateInternship,
  deleteInternship,
  singleUserInternship,
  approveInternship,
  approvedInternshipList,
} from "../actions/internshipAction";

const internshipSlice = createSlice({
  name: "internships",
  initialState: {
    internships: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(updateInternship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateInternship.fulfilled, (state, action) => {
        state.loading = false;
        state.internships = action.payload;
      })
      .addCase(updateInternship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteInternship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteInternship.fulfilled, (state, action) => {
        state.loading = false;
        state.internships = action.payload;
      })
      .addCase(deleteInternship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleInternship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleInternship.fulfilled, (state, action) => {
        state.loading = false;
        state.internships = action.payload;
      })
      .addCase(singleInternship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(newInternship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(newInternship.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.internships = action.payload;
      })
      .addCase(newInternship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleUserInternship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleUserInternship.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.internships = action.payload;
      })
      .addCase(singleUserInternship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(approveInternship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveInternship.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.internships = action.payload;
      })
      .addCase(approveInternship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewInternship.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewInternship.fulfilled, (state, action) => {
        state.loading = false;
        state.internships = action.payload;
      })
      .addCase(viewInternship.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(approvedInternshipList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approvedInternshipList.fulfilled, (state, action) => {
        state.loading = false;
        state.internships = action.payload;
      })
      .addCase(approvedInternshipList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default internshipSlice.reducer;
